<template>
  <div>
    <el-card class="">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('signRule.title') }}</span>
        <el-button v-if="signRuleInfo.signRules.length === 0" style="float: right; padding: 3px 0" type="text" @click="openAddSignRuleModel">
          {{ $t('common.add') }}
        </el-button>
      </div>

      <el-table :data="signRuleInfo.signRules" style="width: 100%" border>
        <el-table-column prop="ruleId" :label="$t('signRule.table.ruleId')" align="center" />
        <el-table-column prop="ruleName" :label="$t('signRule.table.ruleName')" align="center" />
        <el-table-column prop="cycleDays" :label="$t('signRule.table.cycleDays')" align="center" />
        <el-table-column prop="rewardAmount" :label="$t('signRule.table.rewardAmount')" align="center" />
        <el-table-column prop="extraRewardAmount" :label="$t('signRule.table.extraRewardAmount')" align="center" />
        <el-table-column prop="remark" :label="$t('signRule.table.remark')" align="center" />
        <el-table-column :label="$t('common.operation')" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="openEditSignRuleModel(scope.row)">
              {{ $t('common.edit') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page="pagination.currentPage" :page-size="pagination.pageSize" :total="pagination.total"
        layout="total, prev, pager, next" @current-change="handlePageChange" />
    </el-card>

    <add-sign-rule ref="addSignRule" @refresh="listSignRules" />
    <edit-sign-rule ref="editSignRule" @refresh="listSignRules" />
  </div>
</template>

<script>
import { querySignRule } from '@/api/admin/sign/signRuleApi'
import AddSignRule from '@/components/admin/sign/addSignRule/addSignRule'
import EditSignRule from '@/components/admin/sign/editSignRule/editSignRule'

export default {
  name: 'SignRule',
  components: {
    AddSignRule,
    EditSignRule
  },
  data() {
    return {
      signRuleInfo: {
        signRules: [],
        conditions: {
          ruleName: '',
          cycleDays: ''
        }
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
    this.listSignRules()
  },
  methods: {
    async listSignRules(page = 1, rows = 10) {
      this.pagination.currentPage = page
      const params = {
        ...this.signRuleInfo.conditions,
        page,
        row: rows,
        statusCd: '0'
      }

      try {
        const res = await querySignRule(params)
        this.signRuleInfo.signRules = res.data || []
        this.pagination.total = res.records || 0
      } catch (error) {
        console.error('获取签到规则列表失败:', error)
      }
    },
    openAddSignRuleModel() {
      this.$refs.addSignRule.open()
    },
    openEditSignRuleModel(row) {
      this.$refs.editSignRule.open(row)
    },
    handlePageChange(currentPage) {
      this.listSignRules(currentPage)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin: 20px;
}
</style>
